import Web3 from 'web3'
import { Wei } from './types'
import { multiply } from '../logic/weis/wei-calculate'

// TODO : move to  logic/weis/wei-permutation
// TODO: use BigNumber instead of number
export const staticWeb3 = new Web3()
export const toWei = (amount: number, decimals: number) => {
  if (amount == undefined || amount === 0) {
    return '0'
  }
  if (decimals == undefined) {
    throw 'toWei: decimals must be well defined when amount is'
  }
  if (!decimals) {
    throw 'toWei: no decimals'
  }
  // TODO: use BigNumber instead of number
  const fixedAmount = amount.toFixed(decimals)
  if (decimals === 18) {
    try {
      return staticWeb3.utils.toWei(fixedAmount, 'ether')
    } catch (error) {
      return '0'
    }
  } else if (decimals === 6) {
    try {
      return staticWeb3.utils.toWei(fixedAmount, 'mwei')
    } catch (error) {
      return '0'
    }
  }
  const v = Math.floor(Number(fixedAmount) * 10 ** decimals).toString()
  return v
}
export const fromWei = (weis: Wei, decimals: number): number => {
  if (weis == undefined || weis === '0') {
    return 0
  }
  if (decimals == undefined) {
    throw 'fromWei: decimals must be well defined when weis is'
  }
  if (decimals === 18) {
    return Number(staticWeb3.utils.fromWei(weis, 'ether'))
  } else if (decimals === 6) {
    return Number(staticWeb3.utils.fromWei(weis, 'mwei'))
  }
  const v = Number(weis) / 10 ** decimals
  return v
}

/**
 * @deprecated and buggy: use floorWei or ceilWei
 * @param floatedWeiAmount
 */
export const weiToString = (floatedWeiAmount: number): Wei => {
  return BigInt(floatedWeiAmount).toString()
}

/**
 * After some calculation, it's important to remove what's after the comma
 * This will truncate the number. See ceilWei
 * @param floatedWeiAmount
 */
export const floorWei = (floatedWeiAmount: number): Wei => {
  return BigInt(Math.floor(floatedWeiAmount)).toString()
}

/**
 * Convert Wei number obtained after calculation into a regular Wei string,
 * approximated with ceil
 */
export const ceilWei = (floatedWeiAmount: number): Wei => {
  return BigInt(Math.ceil(floatedWeiAmount)).toString()
}

export const ZeroWei = '0'

//export const Contract = staticWeb3.eth.Contract

export function weisAreCloseEnough(a: Wei, b: Wei) {
  const x = Number(a)
  const y = Number(b)
  const fraction = 0.001
  const variation = (Math.abs(x - y) / (x + y)) * 100
  return variation < fraction
}

export const maxDeadline = staticWeb3.utils.toTwosComplement(-1)
export const maxApprove = staticWeb3.utils.toTwosComplement(-1)

export function add(x: Wei, y: Wei): Wei {
  const r = staticWeb3.utils.toBN(x).add(staticWeb3.utils.toBN(y))
  return r.toString()
}

export function minus(x: Wei, y: Wei): Wei {
  const r = staticWeb3.utils.toBN(x).sub(staticWeb3.utils.toBN(y))
  return r.toString()
}

// exemple '0.1' USD will give 10000 Wei with 6 decimals
export function numericTextAsWei(n: string, d: number): Wei | undefined {
  if (n === '') {
    // by convention, empty text is equivalent to undefined Weis
    return undefined
  }

  const parsed = parseExponent(n, d)
  if (parsed === undefined) {
    return undefined
  }
  const f = fractionalPart(parsed)

  const fraction = f.fraction.slice(0, d)

  const padded = fraction.padEnd(d, '0')

  const weis = f.integer + padded
  const cleanWeis = removeStartingZeros(weis)
  if (cleanWeis === '') {
    return '0'
  }
  return cleanWeis
}

export function weiToNumericText(n: Wei | undefined, d: number): string {
  // by convention, the text field is empty if weis are undefined
  if (n === undefined) {
    return ''
  }
  n = removeStartingZeros(n) // start with clean number
  if (n.length === 0) {
    return '0'
  }
  // case where there is less than d numbers => result < 1
  if (n.length === d) {
    return `0.${removeEndingZeros(n)}`
  } else if (n.length < d) {
    n = n.padStart(d, '0')
    return `0.${removeEndingZeros(n)}`
  } else {
    // n.length > d
    const integer = n.slice(0, n.length - d)
    let decimal = n.slice(n.length - d)
    decimal = removeEndingZeros(decimal)
    if (decimal === '0') {
      return integer
    } else {
      return `${integer}.${decimal}`
    }
  }
}

function removeStartingZeros(n: string): string {
  if (n.charAt(0) === '0') {
    return removeStartingZeros(n.slice(1))
  }
  return n
}
function removeEndingZeros(n: string): string {
  if (n.length === 0) {
    return ''
  }
  if (n === '0') {
    return '0'
  }

  if (n.charAt(n.length - 1) === '0') {
    n = n.slice(0, n.length - 1)
    return removeEndingZeros(n)
  }
  return n
}

function fractionalPart(n: string) {
  const i = n.indexOf('.')
  if (i >= 0) {
    const fraction = n.slice(i + 1)

    let integer = n.slice(0, i)
    if (parseInt(integer) === 0) {
      integer = ''
    }
    return {
      fraction,
      length: fraction.length,
      start: i,
      integer,
    }
  } else {
    return {
      fraction: '',
      length: 0,
      start: -1,
      integer: n,
    }
  }
}

function parseExponent(n: string, d: number): string | undefined {
  if (n.includes('e')) {
    try {
      const parsed = parseFloat(n).toFixed(d)
      return parsed
    } catch (e) {
      return undefined
    }
  } else {
    return n
  }
}
